export const validFromInitialValue = '1900-01-01T00:00:00';
export const validToInitialValue = '9999-12-31T00:00:00';
